<div class="At-Container At-ContainerStoryCamera">
    <div class="overlay"></div>
    <a routerLink="/dashboard" class="At-BackBtnPage"><i class="icon-back-arrow"></i></a>
    <a routerLink="/dashboard" class="At-BackBtnCancel"><i class="icon-cancel"></i></a>
    <div class="At-CameraControls">
        <div class="At-ControlsTop">
            <ul class="d-flex align-items-center justify-content-between">
                <li><a href="javascript:void(0);" class="At-GoLive"><h5>GO LIVE</h5></a></li>
                <li><a href="javascript:void(0);" class="At-IconInfinity"><i class="icon-infinity"></i></a></li>
                <li><a href="javascript:void(0);" class="At-Capture"><i class="icon-picture-capture-button"></i></a></li>
                <li><a href="javascript:void(0);"><h3>Aa</h3></a></li>
                <li><a href="javascript:void(0);" class="At-IconMagic"><i class="icon-magic-pen"></i></a></li>
            </ul>
        </div>
        <div class="At-ControlsBottom">
                <ul class="d-flex align-items-center justify-content-between">
                    <li>
                        <figure>
                            <img src="assets/images/show-gallery.jpg" class="img-fluid" alt="">
                        </figure>
                    </li>
                    <li><a href="javascript:void(0);"><h5>STORY</h5></a></li>
                    <li><a href="javascript:void(0);" class="At-IconCamera"><i class="icon-camera-1"></i></a></li>
                </ul>
        </div>
    </div>

</div>
